import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';
import { Component, OnInit, Injectable } from '@angular/core';
import { GlobalDataService } from './global-data.service';
import { serviziRest } from 'src/environments/environment';


@Injectable({ providedIn: 'root' })



export class AuthService {
  serviziRest: any;

  prova: string = 'provaGlobale';
  constructor(public globalData: GlobalDataService, private http: HttpClient, private storage: StorageService) {

    var val = this.storage.get('token');
    var utente = this.storage.get('username');
    // console.log("sono dentro Auth e ho un token pari a: " + val);


    if (val != undefined && val != null && val != '' && utente != undefined && utente != null && utente != '') {
      this.globalData.isUserLogged = true;
      this.getDatiUtenteSessione();
    } else {
      this.globalData.isUserLogged = false;
    }
  }
  getDatiUtenteSessione() {

    this.serviziRest = serviziRest;

    var tokenSessione = this.storage.get('token');
    var utenteSessione = this.storage.get('username');

    this.globalData.getIsAdmin();
    // console.log(this.tokenValue);
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + tokenSessione
    });

    let postData = {
      "email": utenteSessione

    }



    //  this.http.post('http://ec2-52-47-164-20.eu-west-3.compute.amazonaws.com/sunset-ws/rest/utente/getUtente', postData, requestOptions)
    this.http.post<any>(this.serviziRest.getUtente, postData, { headers })
      .subscribe(data => {
        let tempUserdata = data;
        this.globalData.loggedUser = data;
        this.globalData.datiUtente.nome = tempUserdata.nome;
        this.globalData.datiUtente.cognome = tempUserdata.cognome;
        this.globalData.datiUtente.telefono = tempUserdata.telefono;
        this.globalData.datiUtente.email = tempUserdata.email;
        this.globalData.datiUtente.fotoProfilo = tempUserdata.image;

        this.globalData.isUserLogged = true;

        // Initialize user roles after login
        this.globalData.getIsAdmin();
        this.globalData.getRuoloUtente();

        // console.log("sono a inizio app e il valore username è: " + utenteSessione);



        if (tempUserdata.image != null && tempUserdata.image != undefined && tempUserdata.image != '') {
          this.globalData.fotoProfilo = tempUserdata.image;
        } else {
          this.globalData.fotoProfilo = '';
        }

        // console.log(this.globalData.datiUtente.fotoProfilo);

      }, error => {
        console.log(error.status);

        //  console.log(error);
      });

  }
}
